import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=d40d51d2&"
import script from "./ModalInfo.vue?vue&type=script&lang=js&"
export * from "./ModalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports